import { KYMW0001OutputModel } from "./vo/kymw0001-output.model";
import { MarkCodeInfo } from "./vo/mark-code-info.model";

/**
 * マーク選択画面の値を管理するクラス
 *
 * @export KYMW0001Model
 * @class KYMW0001Model
 */
export class KYMW0001Model {

  // ダイアログタイトル
  public windowTitle: string = '';
  // 呼び出し元判定(0:商品マーク選択、1:企画マーク選択)
  public windowOpenFlg: number;
  
  // マークリスト
  public markCodeList: MarkCodeInfo[] = [];

  // 受注コード
  public orderCode: string = '';

  // 選択済みデータ
  public selectedMarkCodeList: string[] = [];

  // 連携用データ
  public output: KYMW0001OutputModel = null;
}
